/* eslint-disable import/prefer-default-export */
import QueriesKeys from "constants/queryKeys";
import { useQuery } from "react-query";
import { isUserLoggedIn } from "utils";
import { getPrivateJobDetailsV7 } from "utils/apiClientPrivate";

export const useIsJobAppliedAndEligibilityDetails = (jobID: string) =>
	useQuery(
		[QueriesKeys.GET_PRIVATE_JOB_DETAILS, jobID],
		async () => {
			const { data } = await getPrivateJobDetailsV7(jobID);
			return {
				isJobApplied: !!data?.job_info?.user_application,
				job_application_mode: data?.job_info?.job_application_mode,
				job_requirement_mismatch: data?.job_requirement_mismatch_nudge || {},
				working_hour_info: data?.working_hour_info,
				isCandidateEligible: data?.is_matched,
				candidateScore: data?.job_requirement_mismatch_nudge === null ? 0 : -1,
				department_id: data?.job_info?.department_id,
				job_applied_match_nudge: data?.job_applied_match_nudge || {},
				job_applied_mismatch_nudge: data?.job_applied_mismatch_nudge || {},
			};
		},
		{
			enabled: !!isUserLoggedIn(),
		}
	);
